import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import SkeletonSupplies from "../SkeletonLoader/SkeletonSupplies";
import "swiper/scss";
import "swiper/scss/navigation";
import logo from "../../assets/logo.png";
//import { genPdf } from "../../helpers/generatePDF";
//import detectBrowser from "../../helpers/detectBrowser";

import styles from "./Supplies.module.scss";
import { GridInput, GridRadio } from "./Supplies.styled";

// 'adhmix' ('Клейові суміші')
// 'scdfloor' ('Стяжка та підлога')
// 'masmix' ('Мурувальні суміші')
// 'plaster' ('Штукатурки')
// 'intpaint' ('Інтер\'єрні фарби')
// 'tinsul' ('Система теплоізоляції')

const getSlidesPerView = (block, conditions, isDesktop, isTablet, isMobile) => {
  const options = block.options.filter(
    (option) =>
      !(
        conditions.isDisable ||
        (conditions.options &&
          !conditions.options.filter((el) => el.value === option.value).length)
      ),
  );
  const shortLabels = !options?.filter((option) => option.label.length > 10)
    .length;
  const longLabels = options?.filter(
    (option) => option.label.length >= 25,
  ).length;
  const middleLabels = !shortLabels && !longLabels;

  if (isDesktop) {
    if (shortLabels) {
      return options.length < 12 ? options.length : 12;
    } else if (middleLabels) {
      return options.length < 8 ? options.length : 8;
    } else if (longLabels) {
      return options.length < 5 ? options.length : 5;
    }
  } else if (isTablet) {
    if (shortLabels) {
      return options.length < 5 ? options.length : 5;
    } else if (middleLabels) {
      return options.length <= 5 ? options.length : 5;
    } else if (longLabels) {
      if (block.grid !== "1" && block.grid !== "5/6") {
        return options.length <= 2 ? options.length : 2.3;
      } else {
        return options.length <= 6 ? options.length : 6;
      }
    }
  } else if (isMobile) {
    if (shortLabels) {
      return options.length < 5 ? options.length : 4.5;
    } else if (middleLabels) {
      return options.length <= 3 ? options.length : 2.3;
    } else if (longLabels) {
      return options.length < 3 ? options.length : 2.3;
    }
  }
};

const Form = (props) => {
  const [optionInd, setOptionInd] = useState([]);
  const [params, setParams] = useState(null);
  const [conditions, setConditions] = useState(null);
  const navigationPrevRef = React.useRef(Array(16).fill(null));
  const navigationNextRef = React.useRef(Array(16).fill(null));
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  useEffect(() => {
    if (props.box?.length > 0) {
      if (params === null) {
        // setParams({});
        setParams(
          props.box.reduce((memo, block) => {
            if (block.options?.length > 0) {
              memo[block.id] = block.options[0].value;
            }
            return memo;
          }, {}),
        );
      } else {
        setConditions(
          props.box.reduce((memo2, block) => {
            memo2[block.id] = block.conditions.reduce((memo, el) => {
              let match = 0;
              for (let key in el.if) {
                if (el.if[key] !== params[key]) {
                  break;
                }
                match++;
              }
              if (match === Object.keys(el.if).length) {
                memo = { ...memo, ...el.then };
              }
              return memo;
            }, {});
            return memo2;
          }, {}),
        );
      }
    }
  }, [params, props.box]);

  useEffect(() => {
    for (let key in conditions) {
      if (conditions[key].isDisable && params[key] !== undefined) {
        setParams({ ...params, [key]: undefined });
      }
    }
  }, [params, conditions]);

  return (
    <form className={styles.container} onSubmit={props.handleSubmit}>
      <div className={styles.gridContainer}>
        {props.box?.map((block, blockIndex) => {
          const conditions2 = conditions ? conditions[block.id] : {};
          const slidesPerView = getSlidesPerView(
            block,
            conditions2,
            isDesktop,
            isTablet,
            isMobile,
          );

          return (
            <React.Fragment key={blockIndex}>
              {block.type === "select" && (
                <GridRadio type={block.grid}>
                  <fieldset disabled={conditions2.isDisable}>
                    <legend>{block.label}</legend>
                    <div className={styles.carousel}>
                      <button
                        className={styles.swiperButtonPrev}
                        type="button"
                        ref={(el) => {
                          navigationPrevRef.current[blockIndex] = el;
                        }}
                      >
                        <div></div>
                      </button>
                      <Swiper
                        key={blockIndex + isDesktop + isTablet + isMobile}
                        className={styles.swiper}
                        navigation={{
                          nextEl: navigationNextRef.current[blockIndex],
                          prevEl: navigationPrevRef.current[blockIndex],
                          clickable: true,
                        }}
                        observer
                        modules={[Navigation]}
                        spaceBetween={1}
                        slidesPerView={slidesPerView}
                      >
                        {block.options
                          .filter(
                            (option) =>
                              !(
                                conditions2.isDisable ||
                                (conditions2.options &&
                                  !conditions2.options.filter(
                                    (el) => el.value === option.value,
                                  ).length)
                              ),
                          )
                          .map((option, optionIndex) => (
                            <SwiperSlide key={optionIndex}>
                              <input
                                type="radio"
                                onChange={() => {
                                  const newOptionInd = [...optionInd];
                                  newOptionInd[blockIndex] = optionIndex;
                                  setOptionInd(newOptionInd);
                                  setParams({
                                    ...params,
                                    [block.id]: option.value,
                                  });
                                }}
                                name={block.id}
                                id={`${block.label}-${optionIndex}`}
                                value={option.value}
                                checked={
                                  params && params[block.id]
                                    ? params[block.id] === option.value
                                    : false
                                }
                                readOnly={true}
                              />
                              <label htmlFor={`${block.label}-${optionIndex}`}>
                                {option.label}
                              </label>
                            </SwiperSlide>
                          ))}
                      </Swiper>
                      <button
                        className={styles.swiperButtonNext}
                        type="button"
                        ref={(el) => {
                          navigationNextRef.current[blockIndex] = el;
                        }}
                      >
                        <div></div>
                      </button>
                    </div>

                    {block.options[optionInd[blockIndex] ?? 0].description && (
                      <div className={styles.massage}>
                        {block.options[optionInd[blockIndex] ?? 0].description}
                      </div>
                    )}
                  </fieldset>
                </GridRadio>
              )}

              {block.type === "text" && (
                <GridInput type={block.grid}>
                  <fieldset className={block.description && styles.withTooltip}>
                    <legend>
                      <div>{block.label}</div>
                      {/* {block.description ? (
                        <div className={styles.tooltip}>i
                          <div className={styles.tooltiptext}>{block.description}</div>
                        </div>
                      ) : null } */}
                    </legend>
                    <input
                      type="text"
                      step="0.001"
                      maxLength={8}
                      placeholder={block.placeholder}
                      name={block.id}
                      onChange={(e) => {
                        const value = e.currentTarget.value.replace(
                          /[^\d\.]+/g,
                          "",
                        );
                        const pieces = value.split(".", 2);
                        if (pieces.length > 1) {
                          pieces[1].replace(/[^\d]+/g, "");
                        }
                        e.currentTarget.value = pieces.join(".");
                        setParams({
                          ...params,
                          [block.id]: e.currentTarget.value,
                        });
                      }}
                      value={(params && params[block.id]) ?? ""}
                    />
                  </fieldset>
                </GridInput>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div className={styles.submitConteiner}>
        <input
          type="submit"
          value="Розрахувати"
          className={styles.buttonSubmit}
          // disabled={!Object.values(params ?? {}).reduce((memo, el) => memo && !!el, true)}
          disabled={
            !params ||
            !conditions ||
            !props.box?.reduce(
              (memo, block) =>
                memo &&
                (params[block.id] ||
                  conditions[block.id].isDisable ||
                  (block.type !== "text" && !block.options.length)),
              true,
            )
          }
        />
        <div id="scrooll"></div>
      </div>
    </form>
  );
};

const Answer = (props) => (
  <div className={styles.answer}>
    {!props.products.length ? (
      <h2>Необхідних продуктів не знайдено</h2>
    ) : (
      <React.Fragment>
        <div className={styles.printable}>
          <img src={logo} alt="Siltek Logo" />
          <span>0 (800) 60 70 55</span>
        </div>
        <h2>Запропоновані варіанти продуктів</h2>
        <div className={styles.prodactsContainer}>
          {props.products.map((el, i) => (
            <ul key={i} className={styles.prodacts}>
              <li className={styles.img}>
                <img
                  src={el.product.images[0].src}
                  alt={el.product.images[0].name}
                />
              </li>
              <li className={styles.liData}>
                <div className={styles.divData}>
                  <div className={styles.prodactData}>
                    <p className={styles.item}>
                      <span> {el.product.name}</span>
                    </p>
                    <p className={styles.art}>Артикул: {el.product.sku}</p>
                    <p className={styles.ditails}>{el.product.purchase_note}</p>
                  </div>
                  <table className={styles.tableData}>
                    <thead
                      className={
                        props.id === "intpaint"
                          ? styles.tableIntpaint
                          : styles.tableHead
                      }
                    >
                      <tr>
                        {props.id === "intpaint" && <th>Tapa</th>}
                        <th>Кількість, шт.</th>
                        <th>Ціна, грн</th>
                        <th>Вартість, грн</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        {props.id === "intpaint" && (
                          <td>{el.product.weight}</td>
                        )}
                        <td>{el.totalNumber}</td>
                        <td>&asymp; {Number(el.product.price)}</td>
                        <td>&asymp; {el.totalPrice}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button className={styles.btnDetails}>
                  <Link to={el.product.permalink} target="_blank">
                    Детальніше
                  </Link>
                </button>
              </li>
            </ul>
          ))}
        </div>
        <div className={styles.center}>
          <div className={styles.btnFooter}>
            {props.id === "intpaint" && (
              <Link
                to="https://siltek-site.kovalska.dev/inter-yer/"
                target="_blank"
              >
                <button className={styles.btnCanvas}>
                  Підбір кольорів для інтер’єру
                </button>
              </Link>
            )}
            <button
              className={styles.btnSave}
              onClick={() => {
                // const browser = detectBrowser();
                window.print();
                //browser === "safari" ? window.print() : genPdf(props.products, null, 'supplies', props.id);
              }}
            >
              Зберегти результат
            </button>
          </div>
        </div>
      </React.Fragment>
    )}
  </div>
);

function Supplies(props) {
  const [products, setProducts] = useState(null);
  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const params = Object.fromEntries(data.entries());
    props.box.forEach((el) => {
      if (params[el.id] === undefined) {
        params[el.id] = "";
      }
    });
    console.log(props, params);
    setProducts(null);
    setLoader(true);
    fetch("https://siltek-pss.kovalska.work/api", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: 1,
        method: "calculator.get.calculate",
        params: {
          id: props.id,
          params,
        },
      }),
    }).then(async (response) => {
      const data = await response.json();
      console.log(data);
      setProducts(data.result.products);
      setLoader(false);
      document
        .getElementById("scrooll")
        .scrollIntoView({ block: "center", behavior: "smooth" });
    });
  };

  return (
    <div className={styles.wrapper}>
      <Form {...props} handleSubmit={handleSubmit} />
      {!products && <div className={styles.whiterow}></div>}
      {loader && (
        <div className={styles.answer}>
          <SkeletonSupplies style={{ width: "var(--w-m)" }} />
        </div>
      )}
      {products === null ? null : <Answer {...props} products={products} />}
    </div>
  );
}

export default Supplies;
